import React, { useState } from 'react';
import { ListChecks, Trash2 } from 'lucide-react';

const PointsPanel = ({
  selectedCircle,
  points = [],
  pointsLoading,
  pointsError,
  onCreatePoint,
  onDeletePoint,
  selectedCircleIsRole = false,
}) => {
  const [draftTitle, setDraftTitle] = useState('');
  const canAddPoint = Boolean(selectedCircle?.id) && !selectedCircleIsRole;

  const handleAddPoint = async () => {
    const trimmed = (draftTitle || '').trim();
    if (!trimmed || !canAddPoint) return;
    const created = await (onCreatePoint && onCreatePoint(trimmed));
    if (created) setDraftTitle('');
  };

  return (
    <div className="bg-white p-6 rounded-lg shadow-md h-full overflow-hidden flex flex-col">
      <div className="flex items-start justify-between mb-4">
        <div>
          <div className="flex items-center gap-2 text-sm text-emerald-700 font-semibold">
            <ListChecks size={16} />
            Points tactiques
          </div>
          <h2 className="text-xl font-bold text-slate-900">Mes points</h2>
          <p className="text-slate-500 text-sm">Preparez les points a mettre a l'ordre du jour.</p>
        </div>
      </div>

      {pointsError && (
        <div className="mb-3 flex items-center gap-2 text-sm text-red-600 bg-red-50 border border-red-100 px-3 py-2 rounded-lg">
          {pointsError}
        </div>
      )}

      <div className="bg-slate-50 border border-slate-100 rounded-lg p-3 mb-4">
        <div className="flex items-center justify-between">
          <p className="text-xs text-slate-500">
            Cercle: {selectedCircle?.name || 'Aucun cercle sélectionné'}
          </p>
        </div>
        <div className="flex gap-2 mt-2">
          <input
            type="text"
            value={draftTitle}
            onChange={(e) => setDraftTitle(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === 'Enter') handleAddPoint();
            }}
            className="flex-1 border border-slate-200 rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-emerald-100 outline-none"
            placeholder={
              !selectedCircle?.id
                ? 'Sélectionnez un cercle pour ajouter un point'
                : selectedCircleIsRole
                  ? 'Sélectionnez un cercle (pas un role) pour ajouter un point'
                  : 'Ajouter un point...'
            }
            disabled={!canAddPoint}
          />
          <button
            onClick={handleAddPoint}
            className="px-3 py-2 text-xs font-semibold bg-emerald-600 text-white rounded-lg hover:bg-emerald-700 disabled:opacity-50"
            disabled={!canAddPoint || !draftTitle.trim()}
          >
            Ajouter
          </button>
        </div>
      </div>

      <div className="flex-1 bg-white border border-slate-100 rounded-lg p-3 shadow-inner overflow-y-auto">
        {pointsLoading ? (
          <div className="flex items-center justify-center h-full text-slate-400 text-sm">Chargement...</div>
        ) : points.length === 0 ? (
          <div className="text-center text-slate-400 text-sm space-y-1">
            <p>Aucun point enregistré.</p>
            <p className="text-xs">Ajoutez un point pour preparer la réunion tactique.</p>
          </div>
        ) : (
          <div className="space-y-2">
            {points.map((point) => (
              <div
                key={point.id}
                className="w-full text-left p-3 rounded-lg border border-slate-200 bg-slate-50 flex items-start justify-between gap-3"
              >
                <div className="flex-1">
                  <div className="font-semibold text-slate-900 text-sm">{point.title}</div>
                  {point.created_at && (
                    <div className="text-[10px] text-slate-400 mt-1">
                      Cree le {new Date(point.created_at).toLocaleString()}
                    </div>
                  )}
                </div>
                <button
                  onClick={() => onDeletePoint && onDeletePoint(point.id)}
                  className="p-2 rounded-lg border border-slate-200 text-slate-500 hover:text-rose-600 hover:border-rose-200"
                  title="Supprimer"
                >
                  <Trash2 size={14} />
                </button>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default PointsPanel;
